import React from 'react';
import styled from 'styled-components';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaClock } from 'react-icons/fa';
import { PageHero, PageHeroInner, PageWrap, PageInner } from '../components/PageHero';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: #eee;
  border: 1px solid #eee;

  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const Card = styled.div`
  background: white;
  padding: 3rem;

  @media (max-width: 768px) { padding: 2rem; }
`;

const CardTitle = styled.h3`
  font-size: 1rem;
  font-weight: 800;
  color: #03045e;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #eee;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
  padding: 1.2rem 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-of-type { border-bottom: none; }

  .icon {
    width: 40px; height: 40px;
    background: #03045e;
    display: flex; align-items: center; justify-content: center;
    color: #00b4d8;
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  label {
    display: block;
    font-size: 0.72rem;
    color: #aaa;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 3px;
  }

  span {
    color: #333;
    font-size: 0.95rem;
    line-height: 1.6;
  }
`;

const WhatsAppBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  background: #03045e;
  color: white;
  font-weight: 800;
  font-size: 0.9rem;
  margin-top: 2rem;
  letter-spacing: 0.5px;
  transition: all 0.25s ease;

  &:hover { background: #00b4d8; color: #03045e; }
`;

const MapWrap = styled.div`
  height: 320px;
  border: 1px solid #eee;
  margin-bottom: 1.5rem;
  overflow: hidden;

  iframe { width: 100%; height: 100%; border: 0; }
`;

export default function Kontak() {
  return (
    <>
      <PageHero data-title="KONTAK">
        <PageHeroInner>
          <div className="left">
            <span>Hubungi Kami</span>
            <h1>Kontak &<br />Lokasi</h1>
            <p>Kami siap membantu Anda menemukan solusi terbaik</p>
          </div>
          <div className="right">
            <div className="data-title">KONTAK</div>
          </div>
        </PageHeroInner>
      </PageHero>

      <PageWrap>
        <PageInner wide>
          <Grid>
            <Card>
              <CardTitle>Informasi Kontak</CardTitle>
              <ContactItem>
                <div className="icon"><FaPhone /></div>
                <div><label>Telepon</label><span>+62 888 8999 966</span></div>
              </ContactItem>
              <ContactItem>
                <div className="icon"><FaWhatsapp /></div>
                <div><label>WhatsApp</label><span>+62 888 8999 966</span></div>
              </ContactItem>
              <ContactItem>
                <div className="icon"><FaEnvelope /></div>
                <div><label>Email</label><span>passakti@yahoo.com</span></div>
              </ContactItem>
              <ContactItem>
                <div className="icon"><FaClock /></div>
                <div><label>Jam Operasional</label><span>Senin – Sabtu, 08.00 – 17.00 WIB</span></div>
              </ContactItem>
              <ContactItem>
                <div className="icon"><FaMapMarkerAlt /></div>
                <div><label>Alamat</label><span>Jl. Raya Narogong KM. 11 No. 8/9, Limus Nunggal, Cileungsi, Bogor, Jawa Barat 16820</span></div>
              </ContactItem>
              <WhatsAppBtn href="https://wa.me/628888999966" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp size={18} /> Chat via WhatsApp
              </WhatsAppBtn>
            </Card>

            <Card>
              <CardTitle>Lokasi Kami</CardTitle>
              <MapWrap>
                <iframe
                  title="Lokasi Hidrogen.id"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.0!2d106.97!3d-6.47!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwMjgnMDkuMiJTIDEwNsKwNTgnMTIuMCJF!5e0!3m2!1sen!2sid!4v1"
                  allowFullScreen loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </MapWrap>
              <p style={{ color: '#888', fontSize: '0.88rem', lineHeight: 1.8 }}>
                Kunjungi kantor kami di Cileungsi, Bogor. Tim kami siap menyambut dan memberikan
                konsultasi langsung mengenai produk-produk hidrogen terbaik kami.
              </p>
            </Card>
          </Grid>
        </PageInner>
      </PageWrap>
    </>
  );
}
